

























import { Component, Vue } from "vue-property-decorator";
import {
  TitleTemplatePublic,
  RedCapital,
  SelectedCountry,
  RedCapitalConfig,
  State
} from "@/configuration";

@Component({
  metaInfo: {
    title: "En mantención",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry
    };
  }
})
export default class NotFound extends Vue {}
